module.exports = __webpack_public_path__ + "static/media/Culisty.15714e65.md";